module.exports = __webpack_public_path__ + "img/carousel-vet-1.aebbd045.jpg";